import { combineReducers } from 'redux'
import cajas from './cajas'
import cortes from './cortes'

export default combineReducers({
    cajas,
    cortes
})